import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem('exit_intent_shown')) return;
    const showPopup = () => {
      setIsVisible(true);
      sessionStorage.setItem('exit_intent_shown', 'true');
    };
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0) {
        showPopup();
      }
    };
    const isMobile = window.innerWidth < 768;
    let mobileTimer: NodeJS.Timeout;
    if (isMobile) {
      mobileTimer = setTimeout(showPopup, 45000);
    } else {
      document.addEventListener('mouseleave', handleMouseLeave);
    }
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      if (mobileTimer) clearTimeout(mobileTimer);
    };
  }, []);
  const scrollToCheckout = () => {
    setIsVisible(false);
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-124">
      {isVisible && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-teal/60 backdrop-blur-sm overflow-y-auto" data-id="element-125">
          <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.95,
        opacity: 0
      }} className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-5 sm:p-6 md:p-8 my-auto relative overflow-hidden border-2 sm:border-4 border-sage max-h-[90vh] overflow-y-auto" data-id="element-126">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800')] bg-cover bg-center opacity-5 pointer-events-none" data-id="element-127"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-neutral-gray hover:text-teal transition-colors z-10 bg-white/80 rounded-full p-1" data-id="element-128">
              <X size={22} data-id="element-129" />
            </button>

            <div className="text-center relative z-10 pt-2" data-id="element-130">
              <h3 className="font-display font-bold text-lg sm:text-xl md:text-3xl text-teal mb-3 sm:mb-4 leading-tight break-words pr-8" data-id="element-131">
                ⏳ Espera… aún estás a tiempo de recuperar tu bienestar.
              </h3>
              <p className="text-neutral-gray text-sm md:text-base mb-5 sm:mb-6 font-sans break-words" data-id="element-132">
                Antes de irte, recuerda: hoy aún puedes acceder al sistema
                completo con{' '}
                <span className="font-bold text-teal" data-id="element-133">
                  todos los bonos incluidos
                </span>
                . Esta oferta no estará disponible siempre.
              </p>

              <button onClick={scrollToCheckout} className="w-full bg-relief hover:bg-green-600 text-white font-bold py-3 md:py-4 px-4 md:px-8 rounded-full transition-all shadow-lg hover:scale-105 text-sm md:text-lg mb-4" data-id="element-134">
                ✨ QUIERO APROVECHAR ESTA OPORTUNIDAD
              </button>

              <button onClick={() => setIsVisible(false)} className="text-xs md:text-sm text-neutral-gray/60 underline hover:text-neutral-gray transition-colors" data-id="element-135">
                No, prefiero seguir agotada
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}